import he from 'he';
import fp from 'lodash/fp';
import queryString from 'query-string';
import React, { Component } from 'react';
import { Button, Col, Grid, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import Spinner from 'react-spinkit';
import { bindActionCreators } from 'redux';
import { questionType } from '../../../../constants';
import { handleInvalidForm } from '../../../../services';
import { noCapMap } from '../../../../utils';
import { ConfirmationModal, ControlGroup, ControlOption, FormItem, Icon, NumberFormField } from '../../../components';
import ContentQuestionForm from './content-question-form';

class ContentQuestion extends Component {

  constructor() {
    super();

    this.state = {
      showAddNewQuestion: false,
      questions: [],
      isReviewQuestion: false,
      content: {
        quizSize: 1
      },
      validation: {
        quizSize: true,
        quizPassMark: true
      }
    };
  }

  componentDidMount() {
    const contentId = queryString.parse(this.props.location.search).contentId;
    if (contentId) {
      this.props.getContent(contentId);
      this.props.getContentQuestions(contentId);
    }
    else {
      this.props.goTo(this.props.libraryRouteRoot.content);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.contentError) {
      this.setState({
        questions: nextProps.contentQuestions
      });
    }

    const reviwingQuestion = queryString.parse(this.props.location.search).review;
    if (reviwingQuestion) {
      this.setState({
        isReviewQuestion: reviwingQuestion
      });
    }

    if (nextProps.selectedContent && nextProps.selectedContent.id) {
      this.setState({
        content: nextProps.selectedContent
      });
    }
  }

  componentWillUnmount() {
    this.props.resetSelectedContent();
  }

  toggleAddNewQuestion() {
    this.setState({
      showAddNewQuestion: !this.state.showAddNewQuestion
    });
  }

  toggleEditQuestion(question) {
    const updatedQuestions = fp.map((q) => Object.assign({}, q, { isEditing: q.id === question.id ? !question.isEditing : false }))(this.state.questions);
    this.setState({
      questions: updatedQuestions
    });
  }

  deleteQuestion(question) {
    const updatedQuestions = fp.map((q) => Object.assign({}, q, { showConfirmDelete: q.id === question.id }))(this.state.questions);
    this.setState({
      questions: updatedQuestions
    });
  }

  confirmDelete(question) {
    this.props.deleteContentQuestion(this.props.selectedContent.id, question.id);
    this.closeDeleteModal(question);
  }

  closeDeleteModal(question) {
    const updatedQuestions = fp.map((q) => Object.assign({}, q, { showConfirmDelete: false }))(this.state.questions);
    this.setState({
      questions: updatedQuestions
    });
  }

  onQuizPropertyChange(e) {
    const nextContent = Object.assign({}, this.state.content, { [e.name]: e.value });
    this.setState({
      content: nextContent
    });
  }

  validateContentForm() {
    const { content, questions } = this.state;
    const validation = {
      quizSize: (content.quizSize > 0 && content.quizSize <= questions.length) || fp.isEmpty(questions.length),
      quizPassMark: content.quizSize === 1 || (content.quizPassMark > 0 && content.quizPassMark <= content.quizSize)
    };
    this.setState({ validation: validation });
    return fp.all(fp.identity)(validation);
  }

  saveContent(event) {
    event.preventDefault();
    event.stopPropagation();

    const { content, isReviewQuestion } = this.state;
    const nextRoute = isReviewQuestion ? {
      pathname: this.props.libraryRouteRoot.contentDetails,
      search: `?${queryString.stringify({ contentId: content.id })}`
    } : { pathname: this.props.libraryRouteRoot.completedContent };
    if (this.validateContentForm()) {
      this.props.saveContent({
        contentData: {
          content: {
            ...content,
            link: content.pdfContentFileName ? null : content.link
          },
          goals: content.goals,
          cpdCategorys: content.cpdCategorys,
          tags: fp.map((t) => t.text)(content.tags)
        }
      }, nextRoute);
    } else {
      if (this.formRef) {
        handleInvalidForm(this.formRef);
      }
    }
  }

  render() {
    return (
      <div id='section--add-content-questions'>
        <Grid>
          <h1 className='text-center bottom-gap'>Content Questions</h1>
          <h2 className='text-center'>Caddie Tips</h2>
          <p>
            Tip 1: The below question order will be randomised for each quiz. Please ensure each question is stand-alone and doesn't relate to other questions e.g. Don't use "From the previous question, what is the % of funds increased over the same period of time
          </p>
          <p>
            Tip 2: The answer order is also randomised so use "All of these answers" instead of "All of the above" or "None of these answers" instead of "None of the above"
          </p>
          {
            this.state.questions && this.state.questions.length > 0 ?
              noCapMap((question, index) =>
                <div key={question.id}>
                  {
                    question.isEditing ?
                      <ContentQuestionForm
                        saveQuestion={this.props.saveQuestion}
                        contentError={this.props.contentError}
                        selectedContent={this.props.selectedContent}
                        loadedQuestion={question}
                        toggleQuestionForm={() => this.toggleEditQuestion(question)}
                        saveQuestionSuccess={this.props.saveQuestionSuccess} /> :
                      <Row className='md-gutter'>
                        <Col xs={12} md={6} mdOffset={3} className='boxed'>
                          <form noValidate>
                            <div className='question'>
                              <label className='green'>Question {index + 1}</label>
                              <p>{he.decode(question.description)}</p>
                              {
                                question.imageFileUrl ? (
                                  <div className='question-image-display'><img alt="question" src={he.decode(question.imageFileUrl)} /></div>
                                ) : null
                              }
                              {
                                question.questionType === questionType.MultiChoice ?
                                  <ControlGroup id={`correct-answer-${question.id}`} control='checkbox' label={<span className='green'>Answers</span>} colProps={{ xs: 12, sm: 6 }}>
                                    {
                                      fp.map(answer =>
                                        <ControlOption
                                          key={answer.id}
                                          disabled={true}
                                          checked={answer.isCorrect}
                                          label={<span>{he.decode(answer.description)}</span>} />
                                      )(question.answers)
                                    }
                                  </ControlGroup> : null
                              }
                              {
                                question.questionType === questionType.ShortAnswer ?
                                  <div className='short-answer'>
                                    <label className='green'>Answer</label>
                                    <p>{he.decode(fp.first(question.answers).description)}</p>
                                  </div> : null
                              }
                              {
                                question.questionType === questionType.NumericAnswer ?
                                  <div className='numeric-answer'>
                                    <label className='green'>Answer</label>
                                    <p>{he.decode(fp.first(question.answers).description)}</p>
                                  </div> : null
                              }
                              <footer>
                                <Row className='no-gutter'>
                                  <Col xs={6}>
                                    <p>
                                      <Button bsStyle='plain' onClick={() => this.toggleEditQuestion(question)}><Icon icon='edit-large' />&nbsp;Edit question</Button>
                                    </p>
                                  </Col>
                                  <Col xs={6}>
                                    <p>
                                      <ConfirmationModal
                                        show={question.showConfirmDelete}
                                        actions={[
                                          {
                                            onConfirmAction: () => this.confirmDelete(question),
                                            actionLabel: 'Delete',
                                          }
                                        ]}
                                        cancel={() => this.closeDeleteModal(question)}
                                        message={
                                          <p>
                                            You are about to delete question <b>{question.description}</b>
                                          </p>
                                        }
                                        headingText={<span>Delete Question <b>{index + 1}</b></span>}
                                      />
                                      <Button bsStyle='plain' className='warning' onClick={() => this.deleteQuestion(question)}><Icon icon='delete-medium' />Delete question</Button>
                                    </p>
                                  </Col>
                                </Row>
                              </footer>
                            </div>
                          </form>
                        </Col>
                      </Row>
                  }
                </div>
              )(this.state.questions)
              : null
          }
          {
            this.state.showAddNewQuestion ?
              <ContentQuestionForm
                saveQuestion={this.props.saveQuestion}
                contentError={this.props.contentError}
                saveQuestionSuccess={this.props.saveQuestionSuccess}
                selectedContent={this.props.selectedContent}
                toggleQuestionForm={() => this.toggleAddNewQuestion()} /> : null
          }

          {
            !this.state.showAddNewQuestion ?
              <Row className='md-gutter'>
                <Col xs={12} md={6} mdOffset={3} className='boxed'>
                  <div className='first-question'>
                    <Button onClick={() => this.toggleAddNewQuestion()} className='icon-btn' bsStyle='plain'>
                      <Icon icon='plus-large' />
                    </Button>
                    <p>
                      <Button className='large full' onClick={() => this.toggleAddNewQuestion()}>Add question</Button>
                    </p>
                  </div>
                </Col>
              </Row> : null
          }

          <Row className='md-gutter'>
            <Col xs={12} md={6} mdOffset={3} className='boxed'>
              <form ref={(form) => { this.formRef = form; }} noValidate onSubmit={(e) => this.saveContent(e)}>
                {
                  this.state.questions.length > 1 ?
                    <div>
                      <FormItem>
                        <label htmlFor='quiz-size'>Number of questions to be asked</label>
                      </FormItem>
                      <NumberFormField
                        id='quiz-size'
                        name='quizSize'
                        label={null}
                        validation={this.state.validation.quizSize ? null : 'Must be between one and the total number of questions you have entered.'}
                        value={this.state.content.quizSize}
                        onChange={(e) => this.onQuizPropertyChange(e)}
                        required
                        min={1}
                        max={this.state.questions.length}
                        step={1} />
                      {
                        this.state.content.quizSize > 1 ?
                          <div>
                            <FormItem>
                              <label htmlFor='quiz-pass-mark'>Required number of correct answers to earn CPD </label>
                            </FormItem>
                            <NumberFormField
                              id='quiz-pass-mark'
                              name='quizPassMark'
                              label={null}
                              validation={this.state.validation.quizPassMark ? null : 'Must be between one and the number of questions to ask.'}
                              value={this.state.content.quizPassMark}
                              onChange={(e) => this.onQuizPropertyChange(e)}
                              required
                              min={1}
                              max={this.state.content.quizSize}
                              step={1} />
                          </div> : null
                      }
                    </div> : null
                }
                <p className='text-center'>
                  <Button type='submit' className='full large' disabled={this.props.isFetchingContent}>
                    {this.props.isFetchingContent ?
                      <Spinner name='circle' className='spinner' fadeIn='none' /> :
                      'I\'m done adding questions'
                    }
                  </Button>
                </p>
              </form>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
  goTo: bindActionCreators(push, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ContentQuestion);



// WEBPACK FOOTER //
// ./src/containers/pages/shared/publish-content/content-question.js